/* eslint-disable consistent-return */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { Image } from 'react-bootstrap'
import { mobileComputer, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DesktopVideoBannerPreview({ srcs, redirectUrl }) {
  const LeftVideo = srcs.find((s) => s.label === 'Left video')
  const BackgroundImg = srcs.find((s) => s.label === 'Background img')

  const containerRef = useRef(null)

  const [showFloatingVideo, setShowFloatingVideo] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const adRef = useRef(null)

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') return file
    return ''
  }

  const isVideo = (entry) => {
    if (!entry) return false
    if (typeof entry.type === 'string') return entry.type.startsWith('video')
    if (typeof entry.file === 'string')
      return entry.file.endsWith('.mp4') || entry.file.startsWith('blob:')
    return false
  }

  const handleScroll = () => {
    if (!adRef.current || !containerRef.current || !isVideo(LeftVideo)) return

    const rect = adRef.current.getBoundingClientRect()
    const containerRect = containerRef.current.getBoundingClientRect()
    const adVisible =
      rect.top >= containerRect.top && rect.bottom <= containerRect.bottom

    console.log('👉 Scroll check:', {
      adVisible,
      isDismissed,
      showFloatingVideo: !adVisible && !isDismissed,
    })

    setShowFloatingVideo(!adVisible && !isDismissed)
  }

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    container.addEventListener('scroll', handleScroll)
    return () => container.removeEventListener('scroll', handleScroll)
  }, [LeftVideo, isDismissed])

  useEffect(() => {
    handleScroll()
  }, [isDismissed])

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{
        maxHeight: '30.5vh',
        width: '100%',
        overflow: 'auto',
        marginTop: '20%',
      }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobileComputer}
          style={{ width: '38rem', right: '3%', bottom: '25%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '100%', height: '55px', zIndex: '0' }}
          >
            <div className="w-90 m-auto ms-auto">
              <Image
                src={wavenet_logo}
                style={{ height: '45px' }}
                className="ps-3"
              />
            </div>
            <div className="w-10 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="text-end" />
            </div>
          </div>
          <div
            ref={adRef}
            style={{
              border: 'none',
              padding: 0,
              background: 'transparent',
              position: 'relative',
            }}
          >
            <button
              type="button"
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
              style={{
                border: 'none',
                padding: '0',
                cursor: 'pointer',
                position: 'relative',
                background: 'transparent',
              }}
            >
              {/* Background Img */}
              {BackgroundImg?.file && (
                <img
                  src={getPreviewURL(BackgroundImg.file)}
                  alt="Background"
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                    zIndex: 1,
                    position: 'relative',
                  }}
                  className="px-3"
                />
              )}

              {/* Left Video */}
              {LeftVideo?.file && (
                <video
                  src={getPreviewURL(LeftVideo.file)}
                  autoPlay
                  muted
                  controls
                  loop
                  playsInline
                  style={{
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    width: '48%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: 2,
                  }}
                  className="px-3"
                />
              )}
            </button>
            <CIIcon bottom="5%" right="3.5%" />
          </div>

          {showFloatingVideo && (
            <div
              style={{
                position: 'fixed',
                bottom: '38%',
                right: '19%',
                width: '150px',
                height: 'auto',
                zIndex: 3000,
                boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                background: '#000',
                borderRadius: '6px',
                overflow: 'hidden',
              }}
            >
              <video
                src={getPreviewURL(LeftVideo.file)}
                autoPlay
                muted
                controls
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <button
                type="button"
                onClick={() => {
                  setIsDismissed(true)
                  handleScroll()
                }}
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  background: 'rgba(0,0,0,0.5)',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  zIndex: 9999,
                }}
              >
                ✕
              </button>
            </div>
          )}
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>
    </div>
  )
}

DesktopVideoBannerPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

DesktopVideoBannerPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default DesktopVideoBannerPreview
